import { useState } from "react";
import useGlobal from "../../../../store";
import Options from "../../options";
import PopupSettings from "../../../popups/popup.settings";

const UserBar = ({ name }) => {

  const [ globalState, globalActions ] = useGlobal();
  const { sign } = globalActions;

  const [ showUserMenu, setShowUserMenu ] = useState( false );

  const closeUserMenu = () => setShowUserMenu( false );

  // const [ showSettingsPopup ] = PopupSettings();
  const popupSettings = PopupSettings();


  const USER_MENU = [
    {
      text: "Настройки",
      action: popupSettings.show
    },
    {
      text: "Выйти",
      action: sign.Out
    }
  ]

  // function handleBack() {

  //   schema.resetProjectStates();
  //   navigate( user_tariff?.active ? '/' : '/tariff' );

  // }


  return (

    <div className = "user_container pointer relative"> 

      <div onClick = { () => setShowUserMenu( !showUserMenu ) } className = " flex items-center" >

        <div className = "user_name">

          { name }

        </div>

        <div className = "arrow" />

      </div>

      <Options 
        list = { USER_MENU } 
        show = { showUserMenu } 
        close = { closeUserMenu } 
      />
    
    </div>

  );

}

export default UserBar;
